module.exports = __webpack_public_path__ + "img/video.a612b5e4.svg";